import FormInput from "./FormInput";
import Button from "./UI/Button";
import { CardSimple } from "./UI/Card";
import { Paragraph } from "./UI/Typography";
import { zodResolver } from "@hookform/resolvers/zod";
import { updateFamilyInput, updateFamilySchema } from "../features/families/familySchema";
import { useForm } from "react-hook-form";

interface Props {
  onSubmit: (data: updateFamilyInput) => void;
  isLoading: boolean;
  message: string;
  error: string | null;
  defaultValues: updateFamilyInput;
}

const UpdateFamilyForm = ({ onSubmit, isLoading, message, error, defaultValues }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<updateFamilyInput>({
    resolver: zodResolver(updateFamilySchema),
    defaultValues: {
      family: defaultValues.family || "",
      phone: defaultValues.phone || "",
      email: defaultValues.email || "",
      num_of_children: String(defaultValues.num_of_children) || "",
      status: defaultValues.status || "",
      mentorName: defaultValues.mentorName || ""
    },
  });

  const handleSubmitForm = (data: updateFamilyInput) => {
    console.log("Form submitted with data:", data);
    onSubmit(data); 
  };

  return (
    <CardSimple className="min-w-xs mx-auto mt-1 p-3 space-y-1">
      <h2 className="text-3xl font-bold text-center text-primary">עריכת פרופיל משפחה</h2>
      <form onSubmit={handleSubmit(handleSubmitForm)} className="min-w-xs space-y-5">
        <div className="space-y-2">
          <FormInput
            label="שם משפחה"
            type="text"
            register={register("family")}
            error={errors.family?.message}
            placeholder="הכנס שם משפחה"
          />
          <FormInput
            label="טלפון"
            type="tel"
            register={register("phone")}
            error={errors.phone?.message}
            placeholder="הכנס מספר טלפון"
          />
          <FormInput
            label="אימייל"
            type="email"
            register={register("email")}
            error={errors.email?.message}
            placeholder="הכנס אימייל"
          />
          <FormInput
            label="מספר ילדים"
            type="number"
            register={register("num_of_children")}
            error={errors.num_of_children?.message}
            placeholder="הכנס מספר ילדים"
          />
          <FormInput
            label="מלווה"
            type="text"
            register={register("mentorName")}
            error={errors.mentorName?.message}
            placeholder="הכנס שם מלווה"
          />
          <div>
            <label className="block text-sm font-medium text-text-main mb-1">סטטוס</label>
            <select
              {...register("status")}
              className={`w-full bg-white text-text-main rounded-xl px-3 py-2 font-sans text-base shadow-sm border ${
                errors.status ? "border-danger" : "border-border"
              }`}
            >
              <option value="" disabled hidden>בחר סטטוס</option>
              <option value="needs_attention">דורש תשומת לב</option>
              <option value="ok">תקין</option>
              <option value="no_meeting_month">לא נפגשו החודש</option>
            </select>
            {errors.status && <p className="text-danger text-sm mt-1">{errors.status.message}</p>}
          </div>
        </div>
        <Button type="submit" fullWidth isLoading={isLoading}>
          עדכן פרופיל משפחה
        </Button>

        {message && (
          <Paragraph className="text-success text-center font-semibold">
            {message}
          </Paragraph>
        )}

        {error && (
          <Paragraph className="text-danger text-center font-semibold">
            {error}
          </Paragraph>
        )}
      </form>
    </CardSimple>
  );
}

export default UpdateFamilyForm;
